import { createContext, useContext, useState } from "react"
import { IFood, INut } from "../shared/IFood"
import Nuts from "../data/Nutrients"
import Foods from "../data/Foods"
import Utils, { TErrorMsg } from "../libs/Utils"

export type TFoodsContext = {
    ready:boolean
    error:TErrorMsg|undefined
    foods:IFood[]
    nuts:INut[]
    loadFoods:Function
}

const FoodContext = createContext<TFoodsContext>({} as any)
export const useFoods = () => useContext(FoodContext)

export default function FoodProvider(props:{children:JSX.Element}) {
    const [foods,setFoods] = useState<IFood[]>([])
    const [nuts,setNuts] = useState<INut[]>([])
    const [ready,setReady] = useState<boolean>(false)
    const [error,setError] = useState<any>()

    const loadFoods = async () => {
        try {
            const [foods,nuts] = await Promise.all([Foods.i.get(), Nuts.i.get()])
            setFoods(foods)
            setNuts(nuts)
            setReady(true)
            setError(undefined)
        }catch(e){
            const err = Utils.errorMsg(e) 
            setError(err)
            throw err
        }
    }
    return <FoodContext.Provider value={{ready,error,foods,nuts,loadFoods}}>
        {props.children}
    </FoodContext.Provider>
}